import {create} from 'zustand';
import {RatingErrorStore} from './types';

export const useRatingErrorStore = create<RatingErrorStore>(set => ({
	ratingError: false,
	setRatingError: value => set({ratingError: value}),
}));
